import { RegisterItem } from '../../decorators/snitem-factory-decorator';
import { SNItem } from '../snitem';

@RegisterItem()
export class UserDomain extends SNItem {

    public name: string;

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'userdomain';
    }

    public fromJson(json, emitLoaded = true) {
        super.fromJson(json, emitLoaded);
        console.log('UserDomain fromJson', json);
        if (typeof(json.name) !== 'undefined') {
            this.name = json.name;
        }
    }

    public clone(): any {
        return new UserDomain();
    }
}
